<template>
    <div class="listaespera-section">
        <div class="listaespera-content">
            <h2 class="listaespera-title fuente-posm">
                Una Lista de Espera Transparente
            </h2>
            <p class="listaespera-text fuente-nova">
                La principal fuente de estrés de tus clientes es no saber cuando serán atendidos y si su turno en la lista de espera está siendo respetado.
                <br><br>
                Nuestra tecnología asegura que se sientan tranquilos.
            </p>
        </div>
        <div class="listaespera-image">
            <img :src="a65" alt="Lista de espera">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListaEsperaNew',
    data() {
        return {
            a65: require('@/assets/images/a65.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.listaespera-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.listaespera-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.listaespera-image img {
    width: 280px;
    height: auto;
}

.listaespera-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.listaespera-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.listaespera-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .listaespera-title {
        font-size: 60px;
    }

    .listaespera-text {
        font-size: 27px;
    }

    .listaespera-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .listaespera-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .listaespera-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .listaespera-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .listaespera-image img {
        width: 40%;
        max-width: 160px;
    }

    .listaespera-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .listaespera-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
